import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=3f1d213c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1d213c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f1d213c')) {
      api.createRecord('3f1d213c', component.options)
    } else {
      api.reload('3f1d213c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=3f1d213c&scoped=true&", function () {
      api.rerender('3f1d213c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-84M1dJx5PSa0X/JS/comp/SearchFilterTokens.vue"
export default component.exports